

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class AlertDelete extends Vue {
  @Prop({ default: '80' }) readonly size?: string;
}
